import { render, staticRenderFns } from "./CameraModal.vue?vue&type=template&id=5c636526"
import script from "./CameraModal.vue?vue&type=script&lang=js"
export * from "./CameraModal.vue?vue&type=script&lang=js"
import style0 from "./CameraModal.vue?vue&type=style&index=0&id=5c636526&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports